<template>
    <v-content>
        <div id="core-view">
            <v-fade-transition mode="out-in">
                <div
                    v-if="apiError"
                    key="api-error"
                    class="api-error-container"
                >
                    <v-icon large color="error">mdi-alert-circle-outline</v-icon>
                    <p class="api-error-message">{{ apiError }}</p>
                </div>
                <router-view
                    v-else
                    key="router-view"
                />
            </v-fade-transition>
        </div>
    </v-content>
</template>

<script>
export default {
    metaInfo() {
        return {
            title: 'Appmixer Backoffice'
        };
    },
    data() {
        return {
            apiError: null
        };
    },
    watch: {
        $route() {
            this.apiError = null;
        }
    },
    errorCaptured(err) {
        const status = (err.response || {}).status;
        if (status === 401 || status === 403) {
            this.$store.commit('user/unsetAccessToken');
            this.$store.commit('user/unsetRefreshToken');
            this.$store.commit('user/setError', 'Your session has expired. Please sign in again.');
            this.$router.replace('/login');
            return false;
        }
        if (status >= 500) {
            this.apiError = 'Unable to connect to the API. Please try again later.';
            return false;
        }
    }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}

.api-error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  color: #666;
}

.api-error-message {
  margin-top: 16px;
  font-size: 1.1rem;
  text-align: center;
}
</style>
